const files = require.context('.', true, /\.js$/)

let modules = []

files.keys().forEach(key => {
  if (key === './index.js') return

  modules = modules.concat(files(key).default)
})

// 根据 meta.index 排序
modules.sort((a, b) => {
  const idxA = a?.meta?.index ?? -1
  const idxB = b?.meta?.index ?? -1

  return idxA - idxB
})

export default modules
